// const BaseURL = "http://127.0.0.1:8000/api";
const BaseURL = "https://navana.softenginebd.com/api";


// const imgAdminBaseUrl = "http://127.0.0.1:8000/upload/admin_images/";
const imgAdminBaseUrl = "https://navana.softenginebd.com/upload/admin_images/";
// const imgVendorBaseUrl = "http://127.0.0.1:8000/upload/vendor_images/";
const imgVendorBaseUrl = "https://navana.softenginebd.com/upload/vendor_images/";

export default BaseURL;
export { imgAdminBaseUrl };
export { imgVendorBaseUrl };
